import { CertificateProgramEngagementActionBlock } from '@mc/api'
import { LogoMonogram } from '@mc/design-system'
import { EngagementCTA } from './EngagementCTA'

export interface EngagementActionBlockProps {
  defaultEngagement?: CertificateProgramEngagementActionBlock
  engagement?: CertificateProgramEngagementActionBlock
  certUuid: string
  setShowSyllabusModal: (show: boolean) => void
}

export const EngagementActionBlock = ({
  defaultEngagement,
  engagement,
  certUuid,
  setShowSyllabusModal,
}: EngagementActionBlockProps) => {
  // If syllabus is available, add it to the actions
  const finalEngagement = engagement || defaultEngagement

  if (!finalEngagement) return null

  return (
    <>
      <div className='d-flex c-gap-3 align-items-end'>
        {finalEngagement.actions.map((action) => (
          <div key={action.text} className='d-flex align-items-center'>
            <EngagementCTA
              action={action}
              setShowSyllabusModal={setShowSyllabusModal}
              certUuid={certUuid}
            />
          </div>
        ))}
      </div>
      {finalEngagement.details && (
        <div className='d-flex align-items-center'>
          <div
            className='mc-corners--3 mc-p-2'
            style={{ border: '2px solid var(--c-beige-700)' }}
          >
            <LogoMonogram width='1.5em' height='1.5em' />
          </div>
          <p className='mc-px-4 mc-text-small c-text-color--dark'>
            {finalEngagement?.details?.text}
            {finalEngagement.details?.link && (
              <EngagementCTA
                action={finalEngagement.details.link}
                setShowSyllabusModal={setShowSyllabusModal}
                certUuid={certUuid}
              />
            )}
          </p>
        </div>
      )}
    </>
  )
}
